<ui2-button class="button-secondary" (clicked)="openInSignals()">
  <!-- View in Insights (shown when user can't edit/create a search field) -->
  <ng-container *ngIf="!canCreateFilter; else refineInInsights">
    {{ copyOverrides?.detailInSignal || 'newsFeedWidget.detailInSignal' | translate }}
  </ng-container>
  <!-- Refine in Insights (shown when has create/edit permissions) -->
  <ng-template #refineInInsights>
    {{ copyOverrides?.refineFeed || 'newsFeedWidget.header.refineFeed' | translate }}
  </ng-template>
</ui2-button>
